import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const PrimaryButton = ({ children, onClick, className = '', fullWidth = false }) => {
  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`
        relative flex items-center justify-center gap-2 group
        bg-yellow-400 hover:bg-yellow-300 text-black font-black uppercase tracking-wide
        py-3 px-6 rounded transition-colors
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
    >
      {children}
      <SafeIcon icon={FiArrowRight} className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
    </motion.button>
  );
};

export default PrimaryButton;